module.exports = __webpack_public_path__ + "static/media/ser1.671a0db8.jpg";